import {
  ArrowDown24,
  DataViewAlt24,
  DocumentUnknown24,
  Download24,
} from "@carbon/icons-react";
import { Search32 } from "@carbon/icons-react";
import { Form, Loading } from "carbon-components-react";
import {
  Row,
  Column,
  TextInput,
  Button,
  DataTable,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  TableToolbar,
  TableToolbarContent,
} from "carbon-components-react";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import Card from "../../components/Card/Card";
import TablePagination from "../../components/Pagination/Pagination";
import http from "../../http-common";
import { tree } from "d3";
import * as XLSX from "xlsx";

const tableHeaders = [
  {
    header: "Nome",
    key: "name",
  },
  {
    header: "Sexo",
    key: "gender",
  },
  {
    header: "Telefone",
    key: "phoneNumber",
  },
  {
    header: "Estado",
    key: "currentStageDesc",
  },
  {
    header: "Pontuação",
    key: "questionnaireScore",
  },
  {
    header: " ",
    key: "actions",
  },
];

const LinkList = ({ url1, url2, isOpen }) => (
  <ul style={{ display: "flex" }}>
    <li className="mr-1">
      <Link to={url1} title="Consultar Candidatura">
        <DataViewAlt24 />
      </Link>
    </li>
    <li>
      <Link to={url2} title="Consultar Questionário">
        <DocumentUnknown24 />
      </Link>
    </li>
  </ul>
);

const getCellContent = (cell, id) => {
  if (cell.info.header === "actions") {
    return (
      <LinkList
        url1={"../candidature/" + id}
        url2={"../self-knowledge-questionnaire/" + id}
      />
    );
  }

  if (cell.info.header === "gender") {
  }
  return cell.value;
};

const ListCandidaturesPage = () => {
  const [candidatures, setCandidatures] = useState([]);
  const [count, setCount] = useState(0);
  const [size, setSize] = useState(20);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const featchData = async () => {
    try {
      const response = await http.get("/applications/search/q?size=" + size);
      getApplicationData(response);
    } catch (error) {}
  };

  const onPageChange = async ({ page, pageSize }) => {
    try {
      var pag = page - 1;
      const response = await http.get(
        "/applications/search/q?page=" + pag + "&size=" + pageSize
      );
      getApplicationData(response);
    } catch (error) {}
  };

  const onSearch = async (data) => {
    try {
      const response = await http.get(
        `/applications/search/q?name=${data.name}&phoneNumber=${data.phoneNumber}`
      );
      getApplicationData(response);
    } catch (error) {}
  };

  const esportHeaders = [
    { field: "id", headerName: "ID" },
    { field: "dataUseConsent", headerName: "1. Consentimento" },
    { field: "name", headerName: "1.1 Nome Completo" },
    { field: "currentOccupation", headerName: "1.3 Ocupação Actual" },
    { field: "age", headerName: "2. Idade" },
    { field: "gender", headerName: "3. Género" },
    {
      field: "identificationDocTypeDesc",
      headerName: "4. Documento de Identificação",
    },
    {
      field: "otherIdentificationDocType",
      headerName: "4.1 Outro (especifique)",
    },
    { field: "identificationDocNumber", headerName: "4.2 Número do documento" },
    { field: "phoneNumber", headerName: "5. Contacto Principal" },
    { field: "whatsAppNumber", headerName: "6. Contacto com WhastApp" },
    { field: "alternativePhoneNumber", headerName: "7. Contacto Alternativo" },
    { field: "email", headerName: "8. Email" },
    { field: "provinceName", headerName: "9. Província" },
    { field: "districtName", headerName: "10. Distrito" },
    { field: "address", headerName: "11. Endereço" },
    {
      field: "speaksAndUnderstandsPortuguese",
      headerName: "12. Fala Português",
    },
    { field: "writesInPortuguese", headerName: "12.1 Escreve Português" },
    {
      field: "speaksAndWritesInAnotherLanguage",
      headerName: "12.2 Se não, fala e escreve em outra língua?",
    },

    { field: "anotherLanguage", headerName: "12.3 Outra Língua" },
    { field: "academicLevelDesc", headerName: "13 Nível de Escolaridade" },
    {
      field: "otherAcademicLevel",
      headerName: "13.1 Nível de Escolaridade Alternativo",
    },
    {
      field: "businessPhasesDesc",
      headerName: "14. Fase do negócio?",
    },
    { field: "businessName", headerName: "15. Nome do negócio" },
    {
      field: "legalFormDesc",
      headerName: "16. Forma legal do negócio",
    },

    { field: "hasLicense", headerName: "17. Possui Alvará" },
    { field: "usesAccounting", headerName: "18. Usa Registo Contabilístico" },

    { field: "businessManagerDesc", headerName: "19. Gestão do negócio" },
    { field: "totalWorkers", headerName: "20. # trabalhadores" },
    { field: "femaleWorkers", headerName: "21.1 Mulheres" },
    { field: "maleWorkers", headerName: "21.2 Homens" },
    { field: "femaleWorkers18To35", headerName: "22.1 Mulheres (18-35 anos)" },
    { field: "maleWorkers18To35", headerName: "22.2 Homens (18-35 anos)" },
    { field: "minSalary", headerName: "23.1 Salário Mínimo" },
    { field: "maxSalary", headerName: "23.1 Salário Máximo" },
    {
      field: "salaryEvolution",
      headerName: "23.2 Perespectiva de evolução salarial",
    },

    { field: "projectedMinSalary", headerName: "23.3 Mínimo" },
    { field: "projectedMaxSalary", headerName: "23.3 Máximo" },

    { field: "mainClients", headerName: "24 Principais clientes" },
    {
      field: "estimatedCurrentClients",
      headerName: "25.1. Número Actual de Clientes",
    },
    { field: "projectedClientsYear1", headerName: "1º Ano" },
    { field: "projectedClientsYear2", headerName: "2º Ano" },
    { field: "projectedClientsYear3", headerName: "3º Ano" },

    { field: "workAreasDesc", headerName: "26. Em que área trabalhas" },
    { field: "lastYearTotalSales", headerName: "27. Volume de Vendas Mensal" },
    {
      field: "ecommercePlatformDesc",
      headerName: "27.1 Uso de Plataformas de Comércio Eletrónico",
    },
    {
      field: "orderSourceDesc",
      headerName: "27.2 Origem das encomendas",
    },
    {
      field: "knowsPossibleEnvironmentalEffects",
      headerName:
        "28 Conhecimento de Possíveis Efeitos Ambientais do seu Negócio",
    },
    {
      field: "measuresToMinimizeEffects ",
      headerName: "29 Medidas para minimizar tais efeitos",
    },
    {
      field: "knowsHealthAndSafetyAtWork",
      headerName: "30. Conhece regas de higiene e segurança no trabalho",
    },
    {
      field: "willPutIntoPractice",
      headerName: "31. Colocará em práctica",
    },
    {
      field: "hasReceivedRelevantBusinessPerformanceTraining",
      headerName: "32 Já recebeu algum treinamento",
    },
    {
      field: "pastTrainingsDesc",
      headerName: "32.1 Quem ofereceu o treinamento",
    },
    {
      field: "confirmsAvailabilityForTraining",
      headerName: "33. Confirma disponibilidade para formação",
    },
    {
      field: "trainingPreferencesDesc",
      headerName: "34. Capacitação Técnica preferencial",
    },
    {
      field: "hasSpecialNeedsForTraining",
      headerName: "35. Necessidade Especial",
    },
    {
      field: "isAvailableForTrainingOutsideOfResidence",
      headerName:
        "36. Disponibilidade de Participar na Formação noutro Distrito",
    },
    { field: "currentStageDesc", headerName: "Estado da candidatura" },
    { field: "createdAt", headerName: "Data de Inscrição" },
    { field: "questionnaireScore", headerName: "Pontuação Total" },
  ];

  const exportData = async () => {
    setIsLoading(true);
    try {
      const response = await http.get(`/applications/export`);

      const mappedData = response.data.map((item) => {
        const newItem = {};
        esportHeaders.forEach((header) => {
          newItem[header.headerName] = item[header.field];
        });
        return newItem;
      });

      const worksheet = XLSX.utils.json_to_sheet(mappedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Candidaturas");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });

      // Create a link element
      const currentDateTime = new Date()
        .toISOString()
        .replace(/[:.]/g, "-")
        .replace("T", "_")
        .replace("Z", "");
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `export_candidaturas_${currentDateTime}.xlsx`;
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
    } catch (error) {
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  const getApplicationData = (response) => {
    const data = response.data.content.map((c) => ({
      id: c.uuid,
      name: c.name,
      gender: c.genderDesc,
      phoneNumber: c.phoneNumber,
      currentStageDesc: c.currentStageDesc,
      questionnaireScore: c.questionnaireScore,
    }));
    setCandidatures(data);
    setCount(response.data.totalElements);
    setIsLoading(false);
  };

  useEffect(() => {
    featchData();
  }, []);

  return (
    <Card title="Candidaturas">
      <Loading
        active={isLoading}
        description="Active loading indicator"
        withOverlay={true}
      />
      <div className="form-buttons">
        <p></p>
        <Button kind="ghost" onClick={exportData}>
          <Download24 /> Exportar
        </Button>
      </div>

      <DataTable
        rows={candidatures}
        headers={tableHeaders}
        isSortable
        useZebraStyles
      >
        {({ rows, headers, getHeaderProps, getTableProps }) => (
          <TableContainer>
            <TableToolbar aria-label="data table toolbar">
              <TableToolbarContent>
                <Form
                  className="data-table-search-form"
                  onSubmit={handleSubmit(onSearch)}
                >
                  <Row>
                    <Column sm={6} md={8} lg={8}>
                      <TextInput
                        id="name"
                        labelText=""
                        placeholder="Nome"
                        {...register("name")}
                      />
                    </Column>

                    <Column sm={6} md={3} lg={3}>
                      <TextInput
                        id="phoneNumber"
                        labelText=""
                        placeholder="Telefone"
                        {...register("phoneNumber")}
                      />
                    </Column>
                  </Row>
                  <Button type="submit" renderIcon={Search32}>
                    Pesquisar
                  </Button>
                </Form>
              </TableToolbarContent>
            </TableToolbar>
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    <TableHeader {...getHeaderProps({ header })}>
                      {header.header}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id}>
                    {row.cells.map((cell) => (
                      <TableCell key={cell.id}>
                        {getCellContent(cell, row.id)}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DataTable>
      <TablePagination
        currentPageSize={size}
        onPageChange={onPageChange}
        totalItems={count}
      />
    </Card>
  );
};

export default ListCandidaturesPage;
